<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <p class="text-lg my-2 font-medium">Share your link with customers whenever they interact with your business!</p>
    <p class="my-2 mb-4 text-lg">You can use your QR code to make visiting your feedback link easier. <a href="https://www.dummies.com/business/marketing/social-media-marketing/how-to-scan-a-qr-code/" target="_blank">What is a QR Code?</a></p>
    <PurposeSelect />
    <vx-card class="text-center mb-base md:py-20">
    <div class="vx-row flex">
      <div class="vx-col w-full lg:w-1/2 items-center flex flex-col">
        <div class="my-10">
        <feather-icon icon="LinkIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-5 w-5"></feather-icon>
        <p class="text-lg">{{ linkHeading }}</p>
        <vs-button class="px-0 mx-auto lg:text-4xl" type="flat" size="large" :disabled="purposeBlocked" :href="purposeBlocked ? false : $store.getters['dash/feedbackURLPurpose']" target="_blank" icon-pack="feather" icon="icon-external-link" icon-after>{{ displayURL }}</vs-button>
        <p class="text-lg max-w-sm">You can TEST your feedback link under "Manage" > "Survey Flow" by clicking "Full Preview".</p>
        </div>
        <vs-button class="ml-2 mb-1 w-64" type="border" icon-pack="feather" icon="icon-copy" :disabled="purposeBlocked" @click="copyLink">Copy Link</vs-button>
      </div>
      <div class="vx-col w-full lg:w-1/2 ">
        <h3 class="text-center mb-5">QR Code</h3>
        <div class="text-center">
        </div>
        <div class="overflow-auto">
          <div class="w-full md:w-1/2 float-left">
            <img v-if="!purposeBlocked" class="w-2/3 p-4 mx-auto" style="max-width: 300px;" :src="$store.getters['dash/qrfblPurpose64']"/>
          </div>
          <div class="w-full md:w-1/2 float-left text-left pr-8">
            <p class="mt-5">Anyone can scan this QR code with their smartphone, and it will direct them to your {{ purposeNoun }}.</p>
            <p class="mt-5 text-sm">Click below to download, or right click and "Save Image as" to save to your computer.</p>
            <vs-button class="my-2" type="border"  icon-pack="feather" icon="icon-download" :disabled="purposeBlocked" @click="downloadFBLQR">Download QR Code</vs-button>
          </div>
        </div>
      </div>
    </div>
    </vx-card>

    <div class="vx-row">

      <div class="vx-col w-full">
          <div class="text-center my-8">
            <p class="mx-auto max-w-sm mb-5 text-lg">Your feedback surveys works on all modern smartphone, tablet and computer web browsers.</p>
            <img src="@/assets/images/misc/alldevices.png" class="w-40" >
          </div>
      </div>



    </div>

  </div>
</template>


<script>



import PurposeSelect from './components/ptcomponents/PurposeSelect.vue'

export default {
  data () {
    return {

    }
  },
  components: {
    PurposeSelect
  },
  computed: {
    purpose () {
      return this.$store.state.dash.collectPurpose.purpose
    },
    purposeBlocked () {
      return this.$store.getters['dash/purposeBlocked']
    },
    purposeNoun () {
      if (this.purpose === 'review') return 'review request'
      if (this.purpose === 'referral') return 'referral request'
      return 'feedback link'
    },
    linkHeading () {
      if (this.purpose === 'review') return 'Your review request link is'
      if (this.purpose === 'referral') return 'Your referral request link is'
      return 'Your feedback link is'
    },
    displayURL () {
      const url = this.$store.getters['dash/feedbackURLPurpose']
      return url ? url.replace('https://', '') : ''
    }
  },
  methods: {
    downloadFBLQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrfblPurpose64'];
      link.download = this.purpose === 'review' ? 'Review Request QR Code.png'
        : this.purpose === 'referral' ? 'Referral Request QR Code.png'
        : 'Feedback Link QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    copyLink () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.$store.getters['dash/feedbackURLPurpose']).then(() => {
          this.$vs.notify({
            title: 'Link Copied',
            text: 'Your feedback link has been copied to your clipboard.',
            color: 'success',
            time: 5000,
            iconPack: 'feather',
            icon:'icon-check-circle',
            position: 'top-center'})
        }, (err) => {
          console.error('Could not copy text: ', err);
          this.$vs.notify({
            title: 'Error',
            text: 'Could not copy the link.',
            color: 'danger',
            time: 5000,
            iconPack: 'feather',
            icon:'icon-alert-circle',
            position: 'top-center'})
        });
      } else {
        const tempInput = document.createElement('input')
        tempInput.value = this.$store.getters['dash/feedbackURLPurpose']
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        this.$vs.notify({
          title: 'Link Copied',
          text: 'Your feedback link has been copied to your clipboard.',
          color: 'success',
          time: 5000,
          iconPack: 'feather',
          icon:'icon-check-circle',
          position: 'top-center'})
      }
    }
    /*downloadHappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrhappy64'];
      link.download = 'Direct Reviews QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadUnhappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrunhappy64'];
      link.download = 'Direct Complaints QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }*/
  },
  created () {
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
